import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import LikeButton from "../Buttons/LikeButton";
import { isAuth } from "../../services/api/auth";

import {
  FiMoreVertical,
  FiEdit,
  FiShare2,
  FiTrash2,
  FiFlag,
  FiCheck,
  FiX,
} from "react-icons/fi";

import {
  Media,
  Badge,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { deleteComment, editComment } from "../../actions/comment";
import Avatar from "../Avatar";
import { openReportModal } from "../../actions/report";
import { closeLightbox } from "../../actions/lightbox";
import CreateCommentReply from "../CommentReply/CreateCommentReply";
import SingleCommentReply from "../CommentReply/SingleCommentReply";
import CommentReplies from "../CommentReply";

const SingleComment = ({ comment, handleEdit }) => {
  const dispatch = useDispatch();
  const { currentWallpaper: wallpaper } = useSelector(
    (state) => state.lightbox
  );

  const [openReplyCall, createOpenReplyCall] = useState(() => () => {});

  const [values, setValues] = useState({
    editing: false,
    content: comment.content,
    liked: false,
  });
  const { editing, content, liked } = values;

  useEffect(() => {
    if (comment) {
      setValues({
        ...values,
        liked: comment.isLiked,
        content: comment.content,
      });
    }
  }, [comment]);

  const menu = () => {
    return (
      <React.Fragment>
        <UncontrolledDropdown className="ml-2" inNavbar={false}>
          <DropdownToggle tag="a" caret={false}>
            <FiMoreVertical
              className="my-auto h-100"
              color="#7d7d7d"
              size={15}
            />
          </DropdownToggle>
          <DropdownMenu right positionFixed={false}>
            {isAuth() && isAuth()._id == comment.createdBy._id && (
              <DropdownItem
                onClick={() => setValues({ ...values, editing: true })}
              >
                <FiEdit className="mr-2" color="#7d7d7d" size={15} /> Edit
              </DropdownItem>
            )}

            {isAuth() && isAuth()._id == comment.createdBy._id ? null : (
              <DropdownItem
                onClick={() =>
                  dispatch(
                    openReportModal({
                      contentType: "comment",
                      contentId: comment._id,
                    })
                  )
                }
              >
                <FiFlag className="mr-2" color="#7d7d7d" size={15} /> Report
              </DropdownItem>
            )}

            {isAuth() && isAuth()._id == comment.createdBy._id && (
              <React.Fragment>
                <DropdownItem divider />
                <DropdownItem
                  className="text-danger"
                  onClick={() => dispatch(deleteComment(comment._id))}
                >
                  <FiTrash2 className="mr-2" color="" size={15} /> Delete
                </DropdownItem>
              </React.Fragment>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      </React.Fragment>
    );
  };

  const editRender = () => {
    return (
      <React.Fragment>
        <div className="d-flex flex-column w-100">
          <textarea
            className="h-100 w-100 p-2"
            name=""
            id=""
            rows="3"
            value={content}
            onChange={(e) => setValues({ ...values, content: e.target.value })}
            maxLength={200}
          ></textarea>

          <div className="d-flex flex-row pl-2 mt-2">
            <button
              type="button"
              className="btn btn-primary h-auto ml-auto"
              onClick={() =>
                dispatch(editComment(comment._id, content)).then(() => {
                  setValues({ ...values, editing: false });
                })
              }
            >
              {/* <FiCheck className="" color="#ffffff" size={18} /> */}
              Submit
            </button>
            <button
              type="button"
              className="btn btn-danger h-auto ml-2"
              onClick={() => setValues({ ...values, editing: false })}
            >
              {/* <FiX className="" color="#ffffff" size={18} /> */}
              Cancel
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const navigate = useNavigate();
  const profileClicked = () => {
    if (comment && comment.createdBy && comment.createdBy.username) {
      // push
      navigate(`/profile/${comment.createdBy.username}`);

      setTimeout(() => {
        // close modal
        dispatch(closeLightbox());
      }, 0);
    }
  };

  const contentRender = () => {
    return (
      <React.Fragment>
        <Media body>
          <div className="d-flex flex-column">
            <div className="d-flex justify-content-between">
              <a className="font-weight-bold" onClick={profileClicked}>
                {comment &&
                comment.createdBy &&
                wallpaper &&
                wallpaper.createdBy &&
                comment.createdBy._id == wallpaper.createdBy._id ? (
                  <Badge color="secondary" pill style={{ fontSize: "90%" }}>
                    {/* {comment.createdBy.username} */}
                    {comment.createdBy.fullName
                      ? comment.createdBy.fullName
                      : comment.createdBy.username}
                  </Badge>
                ) : comment.createdBy.fullName ? (
                  comment.createdBy.fullName
                ) : (
                  comment.createdBy.username
                )}
              </a>

              <div className="d-inline-flex">
                {isAuth() && isAuth()._id == comment.createdBy._id ? null : (
                  <LikeButton
                    id={comment._id}
                    liked={liked}
                    // handleLike={() => handleVote(comment._id)}

                    handleChange={(value) =>
                      setValues({ ...values, liked: value })
                    }
                    size="sm"
                    type="comment"
                  />
                )}

                {menu()}
              </div>
            </div>
            <p> {comment.content} </p>
            <span className="text-muted">
              {comment && comment.edited && "edited"}
            </span>
            <p className="text-sm text-muted mb-0">
              {moment(comment.createdAt).fromNow()}{" "}
              <a
                className="text-muted font-weight-bold ml-2"
                onClick={() => openReplyCall()}
              >
                Reply
              </a>
            </p>
          </div>

          {/* Create Comment Reply */}
          <CreateCommentReply
            commentId={comment._id}
            createOpenReplyCall={createOpenReplyCall}
          />

          {/* Replies */}
          <CommentReplies comment={comment} key={comment._id} />
        </Media>
        {/* <Media right className="ml-3 d-flex flex-row">
          {isAuth() && isAuth()._id == comment.createdBy._id ? null : (
            <LikeButton
              id={comment._id}
              liked={liked}
              // handleLike={() => handleVote(comment._id)}

              handleChange={(value) => setValues({ ...values, liked: value })}
              size="sm"
              type="comment"
            />
          )}

          {menu()}
        </Media> */}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <Media className="mt-4">
        <Media left>
          <Avatar
            onClick={profileClicked}
            className="mr-2"
            width="auto"
            height="40px"
            src={comment && comment.createdBy.avatar}
            size="sm"
          />
        </Media>
        {editing ? editRender() : contentRender()}
      </Media>
    </React.Fragment>
  );
};

export default SingleComment;
